export default __webpack_public_path__ + "static/media/button-On.7a53a329.png";